import { render, staticRenderFns } from "./Revenue.vue?vue&type=template&id=0ed6b6da&scoped=true&lang=pug"
import script from "./Revenue.vue?vue&type=script&lang=js"
export * from "./Revenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed6b6da",
  null
  
)

export default component.exports